var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('cases-section'),_c('development-stack-section'),_c('facts-section')],1)}
var staticRenderFns = []

export { render, staticRenderFns }